import { IUserAccess } from '~/modules/auth/interfaces/IUserAccess';
import { IResale } from '~/modules/resales/interfaces/IResale';

import { getUserPermissionsIds } from './getUserPermissionsIds';

interface IValidateUserPermissionParams {
  currentAccess: IUserAccess;
  resale: IResale;
  permission?: string;
}

export function validateUserPermission({
  currentAccess,
  resale,
  permission,
}: IValidateUserPermissionParams): boolean {
  if (!currentAccess) return false;

  const userPermissionsIds = getUserPermissionsIds(currentAccess, resale);
  if (userPermissionsIds?.length > 0) {
    return userPermissionsIds.includes(permission);
  }

  return false;
}
